import { useMutation, useQuery } from 'react-query';

import {
  getCreateFinancialMatrixSettings,
  getFinancialSettingsMatrix,
  getUpdateFinancialMatrixSettings,
} from './MatrixFinancialSettings.service';

import { notification } from 'antd';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';
import notificationError from '@/utils/functions/notificationError';

export function useFinancialMatrixSettings(enabled = true) {
  return useQuery(
    ['matrix-financial-settings'],
    () => getFinancialSettingsMatrix(),
    {
      enabled,
      onError(error) {
        notificationError(error);
      },
    },
  );
}

export function useFinancialMatrixSettingsCreate() {
  const queryChanel = useQueryChanel();

  return useMutation(getCreateFinancialMatrixSettings, {
    onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Configurações do financeiro foram criadas com sucesso!',
      });

      queryChanel({
        invalidateQueries: [['matrix-financial-settings']],
        refetchQueries: [['matrix-financial-settings']],
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}

export function useFinancialMatrixSettingsUpdate() {
  const queryChanel = useQueryChanel();

  return useMutation(getUpdateFinancialMatrixSettings, {
    onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Configurações do financeiro foram salvas com sucesso!',
      });

      queryChanel({
        invalidateQueries: [['matrix-financial-settings']],
        refetchQueries: [['matrix-financial-settings']],
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
